import {
  WSCard,
  WSForm,
  WSIconList,
  WSInfoBox,
  WSList,
  WSSectionToolbar,
  WSSelect
} from "@wingspanhq/fe-component-library";
import { WSCardProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSCard/WSCard";
import {
  ProfessionalLiabilityAggregateMinimum,
  ProfessionalLiabilityDeductibleCap,
  ProfessionalLiabilityPerClaimMinimum
} from "@wingspanhq/benefits/dist/src/lib/interfaces/insuranceRequirement";
import { getLimitOptions } from "./getLimitOptions";

export const PER_CLAIM_LIMIT_MINIMUM_COMMON: ProfessionalLiabilityPerClaimMinimum = 1000000;
const PER_CLAIM_LIMIT_MINIMUM: ProfessionalLiabilityPerClaimMinimum[] = [
  250000, 500000, 1000000, 2000000, 5000000
];

export const AGGREGATE_LIMIT_MINIMUM_COMMON: ProfessionalLiabilityAggregateMinimum = 2000000;
const AGGREGATE_LIMIT_MINIMUM: ProfessionalLiabilityAggregateMinimum[] = [
  500000, 1000000, 2000000, 3000000, 5000000
];

export const DEDUCTIBLE_CAP_COMMON: ProfessionalLiabilityDeductibleCap = 50000;
const DEDUCTIBLE_CAP: ProfessionalLiabilityDeductibleCap[] = [
  10000,
  25000,
  50000,
  "NoLimit"
];

const PER_CLAIM_LIMIT_MINIMUM_OPTIONS = getLimitOptions(
  PER_CLAIM_LIMIT_MINIMUM,
  PER_CLAIM_LIMIT_MINIMUM_COMMON
);

const AGGREGATE_LIMIT_MINIMUM_OPTIONS = getLimitOptions(
  AGGREGATE_LIMIT_MINIMUM,
  AGGREGATE_LIMIT_MINIMUM_COMMON
);

const DEDUCTIBLE_CAP_OPTIONS = getLimitOptions(
  DEDUCTIBLE_CAP,
  DEDUCTIBLE_CAP_COMMON
);

export const FormPartialProfessionalLiability: React.FC<
  WSCardProps
> = props => (
  <WSCard {...props}>
    <WSSectionToolbar title="Your requirements for uploaded insurance" />

    <WSList gap="L" mt="L">
      <WSForm.Field
        name="perClaimLimitMinimum"
        label="Per-claim limit (minimum)"
        component={WSSelect}
        componentProps={{
          required: true,
          helperText: "Maximum paid for one incident (select one)",
          options: PER_CLAIM_LIMIT_MINIMUM_OPTIONS
        }}
      />

      <WSForm.Field
        name="totalCoverageLimitMinimum"
        label="Total coverage limit (minimum)"
        component={WSSelect}
        componentProps={{
          required: true,
          helperText:
            "Maximum the insurer pays for all claims combined in the policy year (select one)",
          options: AGGREGATE_LIMIT_MINIMUM_OPTIONS
        }}
      />

      <WSForm.Field
        name="contractorDeductibleMaximum"
        label="Contractor's deductible (maximum allowed)"
        component={WSSelect}
        componentProps={{
          required: true,
          helperText:
            "Most you'll allow contractors to pay out-of-pocket before insurance starts (select one)",
          options: DEDUCTIBLE_CAP_OPTIONS
        }}
      />

      <WSInfoBox
        theme="neutral"
        title="We automatically verify:"
        icon="shield-check-fill"
      >
        <WSIconList
          items={[
            "Valid COI format (not quotes or policy pages)",
            "Contractor name matches our records",
            "Your company listed as certificate holder",
            "Coverage is currently active",
            "Amounts in US dollars",
            "All limits meet your minimums",
            "Deductible within your maximum"
          ]}
          iconProps={{
            name: "check-circle",
            color: "green500"
          }}
        />
      </WSInfoBox>
    </WSList>
  </WSCard>
);
